<template>
    <BasePanel headline="lang_PUBLISHING_TRACKING_PANEL_CAPTION_SETLISTS">
        <template v-slot:panelContent>
            <!-- TODO: Group by must be bind to the year of the date! -->
            <BaseDataTableList                 
                :headers="headers"
                context="Setlists"
                groupBy="year"
                :showExpand="false"                                                   
            />            
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseDataTableList from '@/components/_base/BaseDataTableList'

export default {
    name: "SetlistsPanel",
    components: {
        BasePanel,
        BaseDataTableList
    },
    computed: {      
        /** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */        
        headers() {
            return [
                {text: this.$t('lang_PUBLISHING_TRACKING_SETLISTS_PANEL_CAPTION_FILE'), align: 'left', value: 'fileName'},
                {text: this.$t('lang_PUBLISHING_TRACKING_SETLISTS_PANEL_CAPTION_YEAR'), align: 'left', value: 'year'},
                {text: this.$t('lang_PUBLISHING_TRACKING_SETLISTS_PANEL_CAPTION_RECORDS'), align: 'right', value: 'rows'},
                {text: this.$t('lang_PUBLISHING_TRACKING_SETLISTS_PANEL_CAPTION_IMPORT_DATE'), align: 'left', value: 'importDate'},
                {text: '', align: 'right', value: 'downloadLink', width: "50px"},
                // {text: '', align: 'left', value: 'edit', width: '20px'},
            ]
        }  
    }
}
</script>